/**
*
* Dictionnary extension in the global namespace
* @copyright 2016 BDC
*
* @namespace Dict
* @memberof BDC
* @param {object} @global jQuery
* @param {object} document
* @param {object} window
* @param {object} @namespace BDC
*/
(function ($, document, window, BDC) {
    //'use strict';

    // Define or extend Dict sub-namespace, the Javascript dictionary
    BDC.Dict = $.extend(BDC.Dict, {});

    BDC.Dict = {
        "menuBack": {
            "fr": "Retour",
            "en": "Back"
        },
        "menuClose": {
            "fr": "fermer", 
            "en": "close"
        }
    };
    //Updates the global scope with BDC namespace
    window.BDC = BDC;

}(jQuery, document, window, (window.BDC || {})));

/**
* Utility functions extension in the global namespace
* @copyright 2016 BDC
*
* @namespace Utils
* @memberof BDC
* @copyright 2016 BDC
* @param {object} @global jQuery
* @param {object} document
* @param {object} window
* @param {object} @namespace BDC
*/
(function ($, document, window, BDC) {

    //Exits if jQuery is not loaded (Fatal)
    if (!window.jQuery) {
        console.error("jQuery is not loaded!");
        return false;
    }

    //Extends or create the Utils sub-namespace
    BDC.Utils = $.extend(BDC.Utils, {

        /**
        * Returns value of a specific parameter in URL
        *
        * @function gup
        * @memberof BDC.Utils
        * @param {string} URL parameter
        * @returns {string} parameter value
        */
        gup: function (name) {
            if (typeof name !== "string") return false;

            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            const regexS = `[\\?&]${name}=([^&#]*)`,
                regex = new RegExp(regexS),
                results = regex.exec(BDC.currentUrl);

            return results == null ? "" : results[1];
        },

        /**
        * Returns unique number based on date timestamp
        *
        * @function getUniqueId
        * @memberof BDC.Utils
        * @returns {number} unique ID
        */
        getUniqueId: function () {
            return new Date / 1E3 | 0;
        },

        /**
        * Detect which version of IE is used (if any)
        *
        * @function detectIE
        * @memberof BDC.Utils
        * @returns {boolean|string} IE version of false if not used (or not detected)
        */
        detectIE: function () {
            const ua = window.navigator.userAgent,
                msie = ua.indexOf("MSIE "),
                trident = ua.indexOf("Trident/"),
                edge = ua.indexOf("Edge/");

            if (msie > 0) {
                // IE 10 or older => return version number
                return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)), 10);
            }

            if (trident > 0) {
                // IE 11 => return version number
                const rv = ua.indexOf("rv:");
                return parseInt(ua.substring(rv + 3, ua.indexOf(".", rv)), 10);
            }

            if (edge > 0) {
                // Edge (IE 12+) => return version number
                return parseInt(ua.substring(edge + 5, ua.indexOf(".", edge)), 10);
            }

            // other browser
            return false;
        },

        /**
        * jQuery plugin - Adds a class "active" on top container when clicking on an element
        * You have to pass a jQuery collection of the element you want to have a class active on it when clicked.
        * You declare this in the DocReady state
        *
        * @function toggleActiveClassOnClick
        * @memberof BDC.Utils
        */
        toggleActiveClassOnClick: function () {
            $.fn.toggleActiveClassOnClick = function (leaveOthersOpened) {
                var $elem = $(this);
                leaveOthersOpened = leaveOthersOpened || false;

                $elem.on("click", function () {
                    //e.preventDefault();
                    if (!leaveOthersOpened) $elem.not($(this)).removeClass("active");
                    $(this).toggleClass("active");
                });
            };
        },

        /**
         * Detects if is mobile device
         * Returns true if mobile is detected
         *
		 *@function : isMobileDevice
		 * @memberof BDC.Utils
		 **/
        isMobileDevice: function () {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },

        /**
       * jQuery plugin - returns class list applied on a specific jQuery object.
       * example : $('html').getClassList();
       *
       * @function getClassList
       * @memberof BDC.Utils
       * @returns {object} array of all the classes applied on the element.
       */
        getClassList: function () {
            $.fn.getClassList = function () {
                return this[0].className.split(/\s+/);
            };
        }

    });

    // Updates global scope with BDC namespace
    window.BDC = BDC;

    return true;
})(jQuery, document, window, (window.BDC || {}));

/**
* Cookie functions extension in the global namespace
* @copyright 2016 BDC
*
* @namespace Cookies
* @memberof BDC
* @param {object} @global jQuery
* @param {object} document
* @param {object} window
* @param {object} @namespace BDC
*/
(function ($, document, window, BDC) {
    //"use strict";

    if (!window.jQuery) {
        console.error("jQuery is not loaded!");
        return false;
    }

    //Extends or create Cookies sub-namespace in the global BDC namespace
    BDC.Cookies = $.extend((BDC.Cookie || {}), {

        /**
        * permanent cookie name. will store surveyOpened (true / false)
        *
        * @type string
        */
        cookiePermanentName: "expandableSurvey",

        /**
        * Will store number of visited pages during the session
        *
        * @type string
        */
        cookieSessionNbPages: "expandableSessionNbPages",

        /**
        * will store creation date of the cookie (gmt time) to calculate time laps.
        *
        * @type string
        */
        //
        cookieSessionCreation: "expandableSessionCreation",

        /**
        * will store survey state as it's open or not
        *
        * @type string
        */
        //
        cookieSurveyState: "surveyOpened",

        /**
        * creates a session cookie
        *
        * @function createCookie
        * @memberof BDC.Cookies
        * @param {string} cookie name
        * @param {string} value to put in cookie
        * @param {number} number of days before expiration
        */
        createCookie: function (name, value, days) {
            if (typeof name !== "string") return false;
            //days = days || 365;

            //var expires = "";
            var date, expires;
            if (days) {
                date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // now + days
                expires = `; expires=${date.toGMTString()}`;
                //console.log('expires', expires);
            }
            else {
                expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";

            return true;
        },

        /**
        * Reads an existing cookie
        *
        * @function readCookie
        * @memberof BDC.Cookies
        * @param {string} cookie name
        */
        readCookie: function (name) {
            if (typeof name !== "string") return false;
            const nameEq = name + "=",
                ca = document.cookie.split(";");

            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === " ") c = c.substring(1, c.length);
                if (c.indexOf(nameEq) === 0) return c.substring(nameEq.length, c.length);
            }
            return null;
        },

        /**
        * Erases an existing cookie
        *
        * @function eraseCookie
        * @memberof BDC.Cookies
        * @param {string} cookie name
        */
        eraseCookie: function (name) {
            name = name || "";
            BDC.Cookies.createCookie(name, "", -1);
        },

        /**
        * Check if a cookie exists
        *
        * @function isCookie
        * @memberof BDC.Cookies
        * @param {string} cookie name
        * @returns {boolean} cookie exists of not
        */
        isCookie: function (cookieName) {
            if (typeof cookieName !== "string") return false;
            return (document.cookie.indexOf(cookieName) >= 0 ? true : false);
        }

    });

    //Updates global scope with BDC Namespace
    window.BDC = BDC;

    return true;
})(jQuery, document, window, (window.BDC || {}));


/**
* All the regular functions to get the site running smoothly
* @copyright 2016 BDC
*
* @namespace Main
* @memberof BDC
* @param {object} @global jQuery
* @param {object} document
* @param {object} window
* @param {object} @namespace BDC
*/
(function ($, document, window, BDC) {
    //"use strict";

    if (!window.jQuery) {
        console.error("jQuery is not loaded!");
        return false;
    }

    //Extends of create the "Main" subnamespace in global BDC namespace
    BDC.Main = $.extend((BDC.Main || {}), {

        /**
          FUNCTION NAME : blogContentChange()
          DESCRIPTION : Changes the order of the display of blogger picture once in mobile. Called on resize as well
          ARGUMENTS : None.
          HTML EXAMPLE : /fr/a-propos/qa-ref/qa-contentpage-type/qa-blog-post/
          **/

        /* à supprimer dans un prochain PBI */
        blogContentChange: function () {

            if ($(".js-profile-author").length) {

                const isMobileDevice = $("html").hasClass("media-phone");

                if (isMobileDevice) {
                    //<768 MOBILE
                    //on small screens : display the blogger pic after the title and the top ssocial shares:
                    $(".js-profile-author").insertAfter(".share-this");
                }
                else {
                    //>= 768 LARGE
                    //on large screens, displays the 
                    $(".js-change-display").prepend($(".js-profile-author"));
                }
            }
        },

        /**
        * get viewport size, defines global variable BDC.currentBreakpoint according to Bootstrap 3 standards breakpoints and add proper class to HTML tag
        *
        * @function viewportSize
        * @memberof BDC.Main
        * @returns {array} viewport width and height
        */
        viewportSize: function () {
            var viewPortWidth,
                viewPortHeight,
                breakpoint;

            // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
            if (typeof window.innerWidth != "undefined") {
                viewPortWidth = window.innerWidth,
                viewPortHeight = window.innerHeight;
            }

            // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
            else if (typeof document.documentElement != "undefined" && typeof document.documentElement.clientWidth != "undefined" && document.documentElement.clientWidth !== 0) {
                viewPortWidth = document.documentElement.clientWidth,
                viewPortHeight = document.documentElement.clientHeight;
            }

            // older versions of IE
            else {
                viewPortWidth = document.getElementsByTagName("body")[0].clientWidth,
                viewPortHeight = document.getElementsByTagName("body")[0].clientHeight;
            }

            BDC.isSmallMobile = false;
            BDC.isMobileMode = false;

            if (viewPortWidth < 768) {
                BDC.isSmallMobile = true;
                BDC.isMobileMode = true;
                breakpoint = "phone";
            }
            else if (viewPortWidth >= 768 && viewPortWidth < 992) {
                BDC.isMobileMode = true;
                breakpoint = "tablet";
            }
            else if (viewPortWidth >= 992 && viewPortWidth < 1200) {
                if (BDC.Utils.isMobileDevice() === true) {
                    BDC.isMobileMode = true;
                    breakpoint = "tablet";
                }
                else {
                    breakpoint = "desktop-small";
                }

            }
            else {
                breakpoint = "desktop-large";
            }

            BDC.currentBreakPoint = `media-${breakpoint}`;
            $("html").removeClass("media-phone media-tablet media-desktop-small media-desktop-large").addClass(BDC.currentBreakPoint);

            BDC.viewportWidth = viewPortWidth;
            BDC.viewportHeight = viewPortHeight;

            return [viewPortWidth, viewPortHeight];
        },

        /**
        * Enable behaviors on different custom fields.
        * Also hook the custom field on an hidden input field with the help of a data atribute "field".
        *
        * @function customFieldBehavior
        * @memberof BDC.Main
        */
        customFieldBehavior: function () {
            /**
            * Assign the value of the custom field in the existing input field.
            * If Input field does not exist, it will be created then linked to the custom field.
            *
            * @function linkToInputField
            * @param {object} The jQuery parent custom field
            * @param {string} The field name that links the custom field with the hidden one.  Use : data-field="field_name" on the custom field.
            * @param {string} Value from the custom field to passe to the input hidden field
            */
            if ($(".js-select").length) {
                var navigateTo = function (url) {
                    window.open(url, "_self");
                };

                var showNext = function (target, position) {
                    $(`.${target}`).removeClass("hide");
                    $(".js-select-slide").css("transform", `translate(${position}%, 0)`);
                };

                $(".js-select").each(function () {
                    var $select = $(this),
            			currentPosition = 0;

                    if ($select.hasClass("js-select-with-button")) {
                        const $selectWrapper = $select.closest(".js-select-wrapper"),
                            $selectButton = $selectWrapper.find(".js-select-button");

                        $selectButton.click(function () {
                            if (typeof $select.find(":selected").data("href") === "string") {
                                navigateTo($select.find(":selected").data("href"));
                            }
                            if (typeof $select.find(":selected").data("target") === "string") {
                                currentPosition -= 100;
                                showNext($select.find(":selected").data("target"), currentPosition);
                            }
                        });
                    }
                    else {
                        $select.change(function () {
                            if (typeof $select.find(":selected").data("href") === "string") {
                                navigateTo($select.find(":selected").data("href"));
                            }
                        });
                    }
                });
            }
            //console.log ("customFieldBehavior" + BDC.Utils.getRunningTimeInMs(dateNow, false));
        },

        /**
        *  Manage behaviors of sliders boxes
        * Also hook the custom field on an hidden input field with the help of a data atribute "field".
        *
        * @function boxSlide
        * @memberof BDC.Main
        */
        boxSlide: function () {

            if ($(".js-box-slide").length) {
                $(".js-btn-slider").click(function () {

                    const $boxButton = $(this),
                        $boxArea = $boxButton.closest(".js-box-slide-wrapper"),
                        $boxSlideArea = $boxArea.find(".js-box-slide"),
                        $allBoxButton = $(".js-btn-slider"),
                        $allBoxSlideArea = $(".js-box-slide");

                    if ($boxButton.hasClass("icon-plus")) {
                        $allBoxButton.removeClass("icon-minus").addClass("icon-plus");
                        $allBoxSlideArea.css("transform", "translate(0, 0)");
                        $boxButton.removeClass("icon-plus").addClass("icon-minus");
                        $boxSlideArea.css("transform", "translate(-100%, 0)");
                    }
                    else {
                        $boxButton.removeClass("icon-minus").addClass("icon-plus");
                        $boxSlideArea.css("transform", "translate(0, 0)");
                    }
                });
            }
            //console.log("careerBehavior" + BDC.Utils.getRunningTimeInMs(dateNow, false));
        },

        /**
        * Manage all to deal the differents IFrame scenarios across the webSite depending of the Iframe source
        *
        * @function iFrameManagement
        * @memberof BDC.Main
        */
        iFrameManagement: function () {
            $("iframe").each(function (i, e) {
                const $e = $(e);

                if (typeof $e.attr("src") !== "undefined") {
                

                    if(typeof BDC.domainsList != "undefined"){
                        if ($e.attr("src").indexOf(BDC.domainsList.eloqua.domain) > 0) {
                            let origin = $e.attr("src").split("/");

                            origin = origin[3].split("?");
                            $e.addClass(origin[0]);

                        }
                    }

                }
                else if ((typeof $e.attr("data-src") !== "undefined") && ($e.hasClass("js-gaid"))) {
                    // if iframe contains 'data-src' attribute and has js-gaid as classname, we inject specific local script:
                    const scriptGaid = "/Style%20Library/site/scripts/analytics/pick_send_gaid.min.js";
                    $.getScript(scriptGaid, function () {});
                }

            });
            //console.log ("iFrameManagement" + BDC.Utils.getRunningTimeInMs(dateNow, false));
        },

        /**
        * Manage all to deal the differents IFrame scenarios across the webSite depending of the Iframe source
        *
        * @function iframeListener
        * @param {object} event data sent from the other domain and cought by the listener
        * @param {iframe} ? TBD
        * @memberof BDC.Main
        */
        iframeListener: function (event) {

            let domainFound = false;
            let domain;
            for (let key in BDC.domainsList) {
                if (Object.prototype.hasOwnProperty.call(BDC.domainsList, key)) {
                    domain = `https://${BDC.domainsList[key].domain}`;
                    if (domain === event.origin) {
                        domainFound = true;
                        break;
                    }
                }
            }

            if (domainFound === false) return;

            if (typeof event.data === "string") {
                const msgArray = event.data.split("|");

                if (msgArray[0] === "trigger" && !$(".fancybox-opened").get(0)) {
                    BDC.Utils.gup(msgArray);
                    $(`[data-src="#${msgArray[1]}"]`).trigger("click");
                    $(`#${msgArray[1]}`).find("a").focus();
                    if (msgArray.length > 2) {
                        $(`[data-name="notificationTitle"]`).each(function () {
                            $(this).val(msgArray[2]);
                        });
                        $(`[data-name="sg_id"]`).each(function () {
                            $(this).val(msgArray[3]);
                        });
                        $(`[data-name="surveyID"]`).each(function () {
                            $(this).val(msgArray[4]);
                        });
                        $(`[data-name="assessementName"]`).each(function () {
                            $(this).val(msgArray[5]);
                        });
                        $(`[data-name="assessmentURL"]`).each(function () {
                            $(this).val(msgArray[6]);
                        });
                    }
                }
                if (msgArray[0] === "anchor") {
                    $("html,body").animate({ scrollTop: $(`#${msgArray[1]}`).offset().top }, "slow");
                }

                let numberMsg;
                if (msgArray[0] === "hauteur") {
                    const spacing = 1;
                    numberMsg = parseInt(msgArray[1], 10) - spacing;
                } else {
                    numberMsg = msgArray[0];
                }

                if (!isNaN(Number(numberMsg)) && Number(numberMsg) > 0) {
                    let selector;
                    if (domain === "https://ca.surveygizmo.com" || domain === "https://survey.alchemer-ca.com") {
                        selector = $("#js-frame");
                    } else {
                        selector = $(`.${msgArray[2]}`);
                    }

                    selector.each(function () {
                        if ($(this).parent().hasClass("fancybox-inner") && BDC.Utils.isMobileDevice() === false) {
                            const width = $(`[href$='${$(this)[0].src}']`).data("width");
                            $(this).parent().width(width);
                            $(".fancybox-wrap.fancybox-desktop.fancybox-type-iframe").width(width + 30).css({ left: ($(window).width() - (width + 30)) / 2 });
                            $(this).parent().height(Math.round(numberMsg));
                        }

                        $(this).height(Math.round(numberMsg));
                        if (msgArray[3] !== undefined && msgArray[3] === true) $(this).addClass("send-success");
                    });
                }
            }
        },

        /**
        * Add form class to iframes (won't be necessary once all Eloqua form are epi form)
        *
        * @function addFormClassToIframes
        * @memberof BDC.Main
        */
        addFormClassToIframes: function() {
	    
            $("iframe").each( function(i, e) {
                const $el = $(e);
                if ($el.attr("src") != undefined && $el.attr("src").indexOf("services.bdc.ca") > 0) {
                    let origin = $el.attr("src").split("/");
                    origin = origin[3].split("?");
                    $el.addClass(origin[0]);
                }
            });
        },

        /**
        * Email address decoder to avoid email picks by spam bots.
        * Anchor must have class "email-to".
        * NOTE :  Email address must be specified in the text node of the anchor and in this form : name|AT|bdc|DOT|ca
        * AT will be replaced by a "@" and DOT will be replaced by a "."
        *
        * @function emailSpamProtection
        * @memberof BDC.Main
        */
        emailSpamProtection: function () {

            $('a[href*="mailto:"]').each(function () {
                const $el = $(this);
                var email = String($el.attr("href")).replace("mailto:","").trim();
                
                email = email.replace("|DOT|", ".");
                email = email.replace("|AT|", "@");

                if($el.text().match(/\|DOT\||\|AT\|/) ){
                    $el.text(email);
                }

                $el.attr("href", `mailto:${email}`);
            });
            
        },

        /**
        * A list of jQuery selectors to enhance the DOM in specific situations
        *
        * @function htmlEnhancer
        * @memberof BDC.Main
        */
        htmlEnhancer: function () {

            //Build the Iframe string for section "Manage Subscription" or "Manage Preferences" based on arguments taken in URL and appends the iframe
            if ($("#manageSubsIFrame").length && typeof BDC.domainsList != "undefined") {
                let endUrl = "",
                    eloquaLanding = "";

                if (window.location.hostname === BDC.domainsList.dev.domain || window.location.hostname === BDC.domainsList.local.domain) {
                    endUrl = "_DEV";
                }
                else if (window.location.hostname === BDC.domainsList.test.domain) {
                    endUrl = "_TEST";
                }

                if (/(manage-subscriptions|gerez-abonnements)/.test(BDC.currentUrl)) {
                    eloquaLanding = `Subscription-Management--LP--${BDC.currentLang}_branding${endUrl}`;
                }
                else if (/(manage-preferences|gerez-preferences)/.test(BDC.currentUrl)) {
                    eloquaLanding = `Manage-my-preferences--${BDC.currentLang}${endUrl}`;
                }

                let iFrameHtml = `<iframe id='frmManage' width='700' frameborder='0' class='${eloquaLanding}' src='https://${BDC.domainsList.eloqua.domain}/${eloquaLanding}`;

                if (BDC.urlParams) {
                    const uid = BDC.urlParams["uid"],
                        lid = BDC.urlParams["lid"],
                        elq = BDC.urlParams["elq"],
                        elqaid = BDC.urlParams["elqaid"],
                        elqat = BDC.urlParams["elqat"],
                        elqTrackId = BDC.urlParams["elqTrackId"],
                        email = BDC.urlParams["elqCampaignId"];

                    iFrameHtml += `?s=1896&lid=${lid}&elq=${elq}&elqaid=${elqaid}&elqat=${elqat}&elqTrackId=${elqTrackId}&uid=${uid}${email}`;
                }

                iFrameHtml += "'></iframe>";
                $("#manageSubsIFrame").append(decodeURI(iFrameHtml));
            }
            
        },

        /**
        * Manages Fancybox options and calls depending on the content type and class
        *js-fancybox: class shouldn't be used in the Css.
        *
        * @function fancyBox
        * @memberof BDC.Main
        */
        fancyBox: function () {

            $('[data-fancybox="images"]').fancybox({ 
                  afterLoad : function(instance, current) {
                    current.$image.attr("alt", current.opts.$orig.attr("data-alt") );
                  }
            });

            // keep this function for mpa button integration with Google MAPs API once BDC has an API Key
            $('[data-type="iframe"]').fancybox({
                beforeLoad: function (instance, current) {   

                    if(typeof current.opts.$orig.attr("data-center") != "undefined"){

                        if(typeof current.opts.$orig.attr("data-place-map") == "undefined"){
                            const url = String(current.opts.$orig.attr("data-src")).split("&");

                            //asign first index to final url
                            let finalMapUrl = url[0];

                            //replace maptype
                            finalMapUrl = finalMapUrl.replace("place","view");
                            
                            //start at second indice and add parameters
                            for(let i =1; i<url.length; i++){
                                if(url[i].substring(0, 2) !== "q="){
                                    finalMapUrl += String(`&${url[i]}`);
                                }
                            }
                            
                            //assign src the revised URL
                            current.src = finalMapUrl;
                        }

                        //add latitude and longitude
                        current.src += String(`&center=${current.opts.$orig.attr("data-center")}`);
                    }
                }
            });

        },

        //Start scrllable leftNav
       /**
       * Scrollable Left Nav:
       * Map parts of the page (data-boundary) to a menu option (data-boundary-nav)
       * Hightlight the menu option on scroll and scroll to the right section on click
       * Both data values have to be the exact same
       * js-boundary: to be added in the page so the code is run through
       * data-boundary: to be added on the wrapper of the section
       * data-boundary-nav: to be added on the menu option
       * @function boundary
       * @memberof BDC.Main
       */
        boundary: function () {
            if ($(".js-boundary").length) {
                // Scrolling
                var currentScroll = -1,
                    newScroll,
                    // Boundary
                    currentBoundary = "current",
                    pastBoundary = "past",
                    boundary = $("[data-boundary]"),
                    boundaryNav = $("[data-boundary-nav]"),
                    boundaryNavSelect = $("[data-boundary-nav-select]"),
                    // offset
                    offset = $(window).height() / 2;

                $(window).on("scroll", function () {
                    // update current scroll
                    newScroll = $(window).scrollTop();
                    currentScroll = newScroll;

                    // highlight current boundary
                    boundary.each(function () {
                        const selfBoundary = $(this).attr("data-boundary"),
                            distanceScrollTop = $(this).offset().top,
                            heightElement = $(this).outerHeight(),
                            heightPlusOffset = heightElement + distanceScrollTop;

                        if (currentScroll > distanceScrollTop - offset && currentScroll < heightPlusOffset - offset) {
                            currentBoundary = selfBoundary;
                            if (currentBoundary !== pastBoundary) {
                                //active
                                boundaryNav.removeClass("boundary-active");
                                boundary.removeClass("boundary-active");
                                $(`[data-boundary-nav='${currentBoundary}']`).addClass("boundary-active");
                                $(`[data-boundary='${currentBoundary}']`).addClass("boundary-active");
                                //active select
                                boundaryNavSelect.find("option[data-boundary-nav]").prop("selected", false);
                                boundaryNavSelect.find(`option[data-boundary-nav='${currentBoundary}']`).prop("selected", true);
                                pastBoundary = currentBoundary;
                                //console.log( currentBoundary );
                            }
                        }
                    });
                });

                //destination
                boundaryNav.on("click", function () {
                    const selfBoundary = $(this).attr("data-boundary-nav");

                    $("html, body").animate({
                        scrollTop: ($(`[data-boundary='${selfBoundary}']`).offset().top)
                    }, 500);
                });

                boundaryNavSelect.on("change", function () {
                    const self = $(this),
                        selfBoundary = self.find(":selected").data("boundary-nav"),
                        selfMenu = self.parents("[data-absolute-to-fix]");
                    var mobileOffset = 0;

                    if (selfMenu.length) {
                        mobileOffset = selfMenu.outerHeight() + 24;
                    }

                    $("html, body").animate({
                        scrollTop: ($(`[data-boundary='${selfBoundary}']`).offset().top - mobileOffset)
                    }, 500);
                });
            }
        },

        /**
		*When Clicking on divs with js-clickable-block class, fetch the href attribute to redirect the page to:

		*@function clickableBlocks
		*@member of BDC.Main
		*/
        clickableBlocks: function () {
            $(".js-clickable-block").off().on("click", function (event) {

                const isTargetA = $(event.target).is(".js-clickable-link"),
                    hrefLink = $(this).find(".js-clickable-link").attr("href");
                var targetLink = $(this).find(".js-clickable-link").attr("target");

                if (targetLink === undefined) {
                    targetLink = "_self";
                }

                //fire the window.open, only if other elements within the block than a link is clicked
                if (isTargetA === false) {
                    window.open(hrefLink, targetLink);
                }
            });
        },

        /**
        *By clicking on item with class=js-expand, toggle event is fired on the closest element
        *CLass: js-accordion: should be used only for script.
        *CLass: js-expand: should be used only for script.
        *Includes :
        *Multiple expandos
        *Accordion
        *Hubs
        *
        *@function toggleElement
        *@memberof BDC.Main
        */
        toggleElement: function () {

            const expandClass = ".js-expand",
                accordionClass = ".js-accordion",
                closeContentClass = "close-content",
                showExpandClass = "show-expand",
                expandOpenClass = ".js-expand-open",
                $arrExpand = $(expandClass),

                //single accordion at a time:
                $arrAccordion = $(accordionClass);
            let i,
                $prevSibling,
                $alertBoxHeight = 0;
            const $arrAccordionWrapper = $(".js-accordion-wrapper");

            if ($arrExpand.length > 0) {

                $(".title-expand").each(function () {
                    if (!$(this).find(".icon-expand").length) {
                        $(this).append('<span class="icon-expand">');
                    }
                });

                //Default expando/accordion active: should exist in only one element:
                //Add class js-expand-open. #170869
                if ($(expandOpenClass).length > 0) {
                    $(expandOpenClass).toggleClass(closeContentClass);
                    $(expandOpenClass).next().toggleClass(showExpandClass);
                }

                if ($arrAccordion.length === 0) {
                    //...multiple expandos : free to low cost
                    //The user can choose to open/close expandos

                    for (i = 0; i < $arrExpand.length; i++) {
                        $prevSibling = $arrExpand[i].previousElementSibling;
                        $prevSibling.onclick = function () {
                            this.classList.toggle(closeContentClass);
                            this.nextElementSibling.classList.toggle(showExpandClass);
                        };
                    }
                }
                else {
                    //....single Accordion:
                    //Only one expando at a time, is opened
                    $arrAccordionWrapper.each(function () {
                        const $this = $(this);

                        $this.find(accordionClass).click(function () {
                            const offsetTop = $(this).offset().top,
                                scrollTo = $(`.${closeContentClass}`).length && $(`.${closeContentClass}`).offset().top < offsetTop ? offsetTop - $(`.${showExpandClass}`).height() : offsetTop;

                            $(this).toggleClass(closeContentClass);
                            $(this).siblings(expandClass).toggleClass(showExpandClass);

                            $this.find(expandClass).not($(this).siblings(expandClass)).removeClass(showExpandClass);
                            $this.find(accordionClass).not($(this)).removeClass(closeContentClass);

                            $("html, body").animate({
                                scrollTop: scrollTo - $alertBoxHeight
                            }, 500, function () {

                            });
                        });
                    });

                    $(document).on("click", `a[href^="#"], a[href^="${window.location.pathname}#"]`, function (event) {
                        const linkAnchor = event.target.hash,
                            anchor = $(accordionClass).find(linkAnchor);

                        if (anchor.length) {
                            const itemAccordion = anchor.closest(accordionClass),
                                offsetTop = itemAccordion.offset().top,
                                scrollTo = $(`.${closeContentClass}`).length && $(`.${closeContentClass}`).offset().top < offsetTop ? offsetTop - $(`.${showExpandClass}`).height() : offsetTop;

                            $(expandClass).removeClass(showExpandClass);
                            $(accordionClass).removeClass(closeContentClass);

                            itemAccordion.addClass(closeContentClass);
                            itemAccordion.siblings(expandClass).addClass(showExpandClass);

                            $("html, body").animate({
                                scrollTop: scrollTo - $alertBoxHeight
                            }, 500);
                        }
                    });
                }
            }
        },

        /**
        * Queries Sharepoint to retrieve text or html code based on ID and inject it in the page
        *
        * @function loadBcContentFromSharePoint
        * @memberof BDC.Main
        */

        displayNoteForBusinessCentre: function() {
            if(typeof window.policeNote != "undefined") {
                const note = window.policeNote;
                if(typeof note.url  != "undefined" &&  typeof note.targetElement  != "undefined" ) {
                    const params = {
                        url: note.url, 
                        type: "GET", 
                        contentType: "application/json", 
                        datatype: "text", 
                        async: true,
                        processData: false,
                        error: function (xhr) { 
                            console.log(`Error: ${xhr.statusText}`); 
                        }, 
                        success: function (result) {

                            if($(note.targetElement).length > 0){
                                $(note.targetElement).html(result);    
                            }
                            else{
                                console.log(`Cannot find ${note.targetElement}`);
                            }
                            
                        }
                    };
                    $.ajax(params);
                } else{
                    console.log("url and targetElement Required to Display Note");
                }
            }

        },

        /**
        * Adds Canada map and provinces dots in the contactUs section
        *
        * @function contactUsMap
        * @memberof BDC.Main
        */
        contactUsMap: function () { 
            if ($(".js-map").length) { 
                // Set number of in map dot
                const dotNumber = function () {
                    $(".js-business-list").each(function () {
                        const nbCentres = $(this).find("li").length,
                            province = $(this).data("province");

                        $(`.js-map-dot[data-province="${province}"] .map-dot-number`).html(nbCentres);
                    });
                };

                // Set active province
                var activeProvince = function () {
                    const selectedProvince = $(".js-map-select").val();
                    $(".js-map-prov").removeClass("active hover");
                    $(".js-business-list").addClass("hide");
              
                    $(`.js-business-list[data-province="${selectedProvince}"]`).removeClass("hide");
                    $(`.js-map-prov[data-province="${selectedProvince}"]`).addClass("active");
                };

                // Hover event for map area, img and dot
                $(".js-map-area, .js-map-prov, .js-map-dot").hover(function () { 
                    const province = $(this).data("province");
              
                    $(".js-map-prov").removeClass("hover");
                    $(`.js-map-prov[data-province="${province}"]`).addClass("hover");
                },
                function () {
                    $(".map-img").hover(function () {
                        $(".js-map-prov").removeClass("hover");
                    });
                });
          
                // Click or touchend event for map area, img and dot
                $("area, .js-map-prov, .js-map-dot").on("click touchend", function () {
                  const province = $(this).data("province");
              
                  $(`.js-map-select [value="${province}"]`).prop("selected", true);
                  activeProvince();
                });
          
                // Change event on select
                $(".js-map-select").change(function () {
                  activeProvince();
                });
          
                if($(".js-rwd-image").length) {
                    const scriptPath = "/assets/js/vendors/split/jquery.rwd-image-maps.min.js";
                    //Call the script partner.js:
                    $.getScript(scriptPath, function () {
                        $(".js-rwd-image").rwdImageMaps();
                    });
                };
          
            dotNumber();
            activeProvince();
          }
        },

        /*
		* Adds a slider to free-to-low-cost "tables"
        * @function slidingTable
        * @memberof BDC.Main
        */
        slidingTable: function () {

            $(".js-tabs-trigger").on("click", function (e) {
                e.preventDefault();
                const index = parseInt($(this).attr("data-open-tab"));
                let tabHolderTarget = $(this).attr("data-tab-target");

                //if no tab target defined uses js-tabs-wrapper
                if (typeof tabHolderTarget == "undefined") {
                    tabHolderTarget = "js-tabs-wrapper";
                }

                const tab = $(`.${tabHolderTarget}`).find(`.tabs-list .js-tab:eq(${index})`);
                tab[0].scrollIntoView();
                tab.trigger("click");

                return false;
            });

            if ($(".js-swipe").length) {

                var linkEl = document.head.querySelector('link[href^="/assets/scss/main.min.css?v="]');
                function linkLoaded(link) {
                    return Boolean(link.sheet);
                }
                var isCssLinkLoaded = linkLoaded(linkEl);                
                function timeout() {
                    setTimeout(function () {
                        if (!isCssLinkLoaded) {
                            isCssLinkLoaded = linkLoaded(linkEl);
                            timeout();
                        }
                        else {
                            $(".js-swipe").each(function () {

                                var $wrapper = $(this), // wrapper of the slider element (HtmlElement)
                                    $prevButton = $wrapper.find(".js-swipe-prev"), // Previous button (HtmlElement)
                                    $nextButton = $wrapper.find(".js-swipe-next"), // Next button (HtmlElement)
                                    $menu,
                                    $tabsSlider,
                                    $tableHeader,
                                    $tableLines,
                                    $tabs,
                                    $tabsContent,
                                    $tabsMarker,
                                    clickCount = 0,
                                    positionTabMarker = 0,
                                    positionTabSlider = 0,
                                    minPositionTabSlider = 0,
                                    maxPositionTabSlider,
                                    i,
                                    startSwipe,
                                    navigationStatus,
                                    tabWidth,
                                    activeTab,
                                    recalculateArrowsOnResize,
                                    containerWidth,
                                    detectSwipe,
                                    tabMargin,
                                    pathName;

                                // Variables necessary for js-table-swipe
                                if ($wrapper.hasClass("js-table-swipe")) {
                                    $menu = $wrapper.find(".js-table-swipe-menu"); // The element where the menu will be inserted (HtmlElement)
                                    $tableHeader = $wrapper.find(".js-table-swipe-header span"); // Table column header (NodeList)
                                    $tableLines = $wrapper.find(".available-features"); // Table lines (NodeList)
                                }
                                // Variables necessary for js-tabs-swipe
                                else if ($wrapper.hasClass("js-tabs-swipe")) {
                                    pathName = BDC.currentUrl; // URL for the verification if another tab should be active
                                    $tabs = $wrapper.find(".js-tab"); // All tabs (NodeList)
                                    $tabsSlider = $wrapper.find(".js-tabs-slider"); // Element that is moving inside the overflow hidden (HtmlElement)
                                    $tabsContent = $wrapper.parent(".js-tabs-wrapper").find(".js-tab-content"); // The content associated with each tabs (HtmlElement)
                                    $tabsMarker = $wrapper.find(".js-tab-marker"); // Marker indicating wich tab is active (HtmlElement)
                                    tabMargin = parseInt($tabs.css("marginRight")); // Margin right of the tabs
                                    tabWidth = $tabs.outerWidth() + tabMargin; // Get the total width of a tab, margin included
                                    maxPositionTabSlider = ((tabWidth * $tabs.length) - tabMargin) - containerWidth; // Set the maximum position of the slider
                                    activeTab = $(".js-tab-active").length > 0 ? $(".js-tab-active").index() : 0; // Indicate the active tabs
                                    containerWidth = $wrapper.width(); // Get the width of the container
                                }
                                // Variables necessary for js-slider-swiper
                                else if ($wrapper.hasClass("js-slider-swipe")) {
                                    $menu = $wrapper.find(".js-slider-swipe-menu");
                                    $wrapper.$slides = $wrapper.find(".js-slide");
                                }

                                // Slider navigation
                                var SliderNav = function (tableHeader, menuHtmlElement) {
                                    this.menu = [];
                                    this.columnCount = 0;
                                    if ($wrapper.hasClass("js-table-swipe")) {
                                        this.columnPerPage = 4;

                                        if (BDC.currentBreakPoint === "media-desktop-large") {
                                            this.columnPerPage = 5;
                                        }
                                    }
                                    else if ($wrapper.hasClass("js-slider-swipe")) {
                                        var topInitial = 0,
                                            numberColumn = 0;

                                        $wrapper.$slides.each(function () {
                                            const positionTop = $(this).position().top;

                                            if (topInitial === 0) {
                                                topInitial = positionTop;
                                            }
                                            if (topInitial === positionTop) {
                                                numberColumn++;
                                            }
                                        });

                                        this.columnPerPage = numberColumn;
                                    }

                                    // Provide a table with name of columns in the HTML
                                    this.getHeader = function () {
                                        if (tableHeader.length > this.columnPerPage) {
                                            const menuArray = [];
                                            for (i = 0; i < tableHeader.length; i++) {
                                                // Update the table header
                                                // add an entry in the control bar for each column found
                                                menuArray.push(tableHeader[i].innerHTML);
                                                menuHtmlElement[0].innerHTML += `<span class='swipe-selector'><span class='item-p' data-count='${i}'></span></span>`;
                                            }
                                            this.columnCount = menuArray.length; // update the number of columns found
                                            this.menu = menuArray; // crate the table with all header (strings)
                                            this.paginate(0, this.columnPerPage, this.columnCount); // set the pagination to 0 by default
                                            startSwipe(); // launch the listeners
                                            navigationStatus();
                                        } else {
                                            $wrapper.addClass("unswipe-table");
                                        }
                                    };
                                    // pagination - page suivante
                                    this.nextPage = function () {

                                        // If table or slider
                                        if ($wrapper.hasClass("js-table-swipe") || $wrapper.hasClass("js-slider-swipe")) {

                                            if (clickCount >= (this.columnCount - this.columnPerPage)) {
                                                clickCount = this.columnCount - this.columnPerPage;
                                            } else {
                                                clickCount += 1;
                                            }
                                            this.paginate(clickCount, this.columnPerPage, this.columnCount);
                                        }
                                        // If tabs
                                        else if ($wrapper.hasClass("js-tabs-swipe")) {
                                            positionTabSlider = positionTabSlider + tabWidth;

                                            if (positionTabSlider >= maxPositionTabSlider) {
                                                positionTabSlider = maxPositionTabSlider;
                                            }
                                            $tabsSlider.css("transform", `translate(-${positionTabSlider}px, 0)`);
                                        }

                                        navigationStatus();
                                    };
                                    // pagination - previous page
                                    this.prevPage = function () {

                                        // If table or slider
                                        if ($wrapper.hasClass("js-table-swipe") || $wrapper.hasClass("js-slider-swipe")) {

                                            if (clickCount > 0) {
                                                clickCount -= 1;
                                            }
                                            this.paginate(clickCount, this.columnPerPage, this.columnCount);
                                        }
                                        // If tabs
                                        else if ($wrapper.hasClass("js-tabs-swipe")) {
                                            positionTabSlider = positionTabSlider - tabWidth;

                                            if (positionTabSlider <= minPositionTabSlider) {
                                                positionTabSlider = minPositionTabSlider;
                                            }
                                            $tabsSlider.css("transform", `translate(-${positionTabSlider}px, 0)`);
                                        }

                                        navigationStatus();
                                    };
                                    // pagination of the elements
                                    this.paginate = function (start, scale, maxScale) {

                                        const displayStart = start;
                                        var displayEnd = parseInt(displayStart) + parseInt(scale);

                                        // limit
                                        if (displayEnd > maxScale) {
                                            displayEnd = maxScale;
                                        }
                                        // menu - indicator
                                        if ($menu) {
                                            const visualMenu = $wrapper.find(".item-p"); // (NodeList)
                                            for (i = 0; i < visualMenu.length; i++) {
                                                if (i >= displayStart && i < displayEnd) {
                                                    $(visualMenu[i]).addClass("item-p-active");
                                                }
                                                else {
                                                    $(visualMenu[i]).removeClass("item-p-active");
                                                }
                                            }
                                        }
                                        if ($wrapper.hasClass("js-table-swipe")) {
                                            // header
                                            for (i = 0; i < $tableHeader.length; i++) {
                                                if (i < displayStart || i >= displayEnd) {
                                                    $($tableHeader[i]).addClass("d-block d-md-none");
                                                } else {
                                                    $($tableHeader[i]).removeClass("d-block d-md-none");
                                                }
                                            }
                                            // table
                                            for (i = 0; i < $tableLines.length; i++) {
                                                const cells = $($tableLines[i]).find(".expandable-data-col");
                                                for (let cell = 0; cell < cells.length; cell++) {
                                                    if (cell < displayStart || cell >= displayEnd) {
                                                        $(cells[cell]).addClass("d-md-none").removeClass("d-md-inline-block");
                                                    } else {
                                                        $(cells[cell]).removeClass("d-md-none").addClass("d-md-inline-block");
                                                    }
                                                }
                                            }
                                        }
                                        else if ($wrapper.hasClass("js-slider-swipe")) {
                                            // Slides
                                            for (i = 0; i < $wrapper.$slides.length; i++) {
                                                if (i < displayStart || i >= displayEnd) {
                                                    $($wrapper.$slides[i]).addClass("hide");
                                                } else {
                                                    $($wrapper.$slides[i]).removeClass("hide");
                                                }
                                            }
                                        }

                                        clickCount = displayStart;
                                        navigationStatus();
                                    };

                                    this.resetActiveTab = function () {
                                        //console.log("Triggering new search");
                                        activeTab = 0;
                                        positionTabSlider = 0;
                                        $wrapper.app.setActiveTab();
                                        recalculateArrowsOnResize();
                                    };

                                    // Set the active tab
                                    this.setActiveTab = function () {
                                        $tabs.removeClass("tab-active js-tab-active");
                                        $($tabs[activeTab]).addClass("tab-active js-tab-active");
                                        $tabsContent.addClass("hide");
                                        $($tabsContent[activeTab - $($tabs[activeTab]).prevAll(".tab-small-disabled").length]).removeClass("hide");
                                        positionTabMarker = tabWidth * activeTab;
                                        $tabsMarker.css("transform", `translate(${positionTabMarker}px, 0)`);

                                        this.setAnchorTiles();
                                    };

                                    this.setAnchorTiles = function () {
                                        $(".js-tabs-anchor-tiles-wrapper .js-tabs-anchor-tile").each(function (index) {
                                            index === activeTab ? $(this).addClass("hide") : $(this).removeClass("hide");
                                        });
                                    };

                                    // Set arrows for tabs where they appear depending of width of the container
                                    this.setArrows = function () {
                                        if ((tabWidth * $tabs.length) - tabMargin > $wrapper.outerWidth()) {
                                            $wrapper.addClass("tabs-container-arrow");

                                            $prevButton.removeClass("hide");
                                            $nextButton.removeClass("hide");

                                            containerWidth = $wrapper.width();
                                            maxPositionTabSlider = ((tabWidth * $tabs.length) - tabMargin) - containerWidth;
                                        }
                                        else if ($wrapper.hasClass("tabs-container-arrow")) {
                                            $wrapper.removeClass("tabs-container-arrow");
                                            $prevButton.addClass("hide");
                                            $nextButton.addClass("hide");

                                            containerWidth = $wrapper.width();
                                            maxPositionTabSlider = ((tabWidth * $tabs.length) - tabMargin) - containerWidth;
                                        }
                                    };


                                    $(window).on("getNewSearchResults", this.resetActiveTab);

                                };

                                recalculateArrowsOnResize = function () {
                                    // Verify if arrow is needed
                                    containerWidth = $wrapper.width();
                                    maxPositionTabSlider = ((tabWidth * $tabs.length) - tabMargin) - containerWidth;

                                    $wrapper.app.setArrows();

                                    // If tabs slider should be moved due to resize
                                    if (positionTabSlider > maxPositionTabSlider) {
                                        positionTabSlider = maxPositionTabSlider;
                                    }
                                    if (positionTabSlider < minPositionTabSlider) {
                                        positionTabSlider = minPositionTabSlider;
                                    }

                                    $tabsSlider.css("transform", `translate(-${positionTabSlider}px, 0)`);

                                    navigationStatus();
                                };

                                startSwipe = function () {

                                    // Click on previous button
                                    $prevButton.click(function (evt) {
                                        evt.preventDefault();
                                        $wrapper.app.prevPage();
                                    });
                                    // Click on next button
                                    $nextButton.click(function (evt) {
                                        //console.log($nextButton);
                                        evt.preventDefault();
                                        $wrapper.app.nextPage();
                                    });
                                    // swipe left (Hammer.js)
                                    detectSwipe.on("swipeleft", function () {
                                        $wrapper.app.nextPage();
                                    });
                                    // swipe right (Hammer.js)
                                    detectSwipe.on("swiperight", function () {
                                        $wrapper.app.prevPage();
                                    });

                                    // If table or slider
                                    if ($wrapper.hasClass("js-table-swipe") || $wrapper.hasClass("js-slider-swipe")) {
                                        // menu clicable
                                        $menu.click(function (evt) {
                                            if ($(evt.target).hasClass("item-p")) {
                                                let dataToNumber = Number(evt.target.dataset.count);
                                                clickCount = dataToNumber;
                                                if (dataToNumber > ($wrapper.app.columnCount - $wrapper.app.columnPerPage)) {
                                                    dataToNumber = ($wrapper.app.columnCount - $wrapper.app.columnPerPage);
                                                }
                                                $wrapper.app.paginate(dataToNumber, $wrapper.app.columnPerPage, $wrapper.app.columnCount);
                                            }
                                            navigationStatus();
                                        });
                                    }
                                    // If tabs
                                    else if ($wrapper.hasClass("js-tabs-swipe")) {
                                        // On click on tab
                                        $tabs.click(function () {

                                            if (!$(this).hasClass("tab-small-disabled")) {

                                                // Set the tab clicked as the active tab
                                                activeTab = $(this).index();
                                                $wrapper.app.setActiveTab();

                                                // Verify if we need to check if there's a posibility that the clicked tab isn't fully visible
                                                if ($wrapper.hasClass("tabs-container-arrow")) {
                                                    const posActiveTab = -(positionTabSlider - (tabWidth * (activeTab))); // Calculate the position the active tab should have

                                                    if (posActiveTab < minPositionTabSlider) {
                                                        $wrapper.app.prevPage();
                                                    }
                                                    else if ((posActiveTab + tabWidth - tabMargin) > containerWidth) {
                                                        $wrapper.app.nextPage();
                                                    }
                                                }
                                            }
                                        });

                                        // If the screen is resized or the orientation of the device changed
                                        $(window).on("resize orientationchange", recalculateArrowsOnResize);
                                    }


                                }; //END startSwipe()

                                navigationStatus = function () {

                                    var $chevronPrev = $wrapper.find(".js-swipe-prev"),
                                        $chevronNext = $wrapper.find(".js-swipe-next");

                                    // If chevron-swipe is not on the element where the click is verified
                                    if (!$chevronPrev.hasClass("chevron-swipe")) {
                                        $chevronPrev = $prevButton.find(".chevron-swipe");
                                    }
                                    if (!$chevronNext.hasClass("chevron-swipe")) {
                                        $chevronNext = $nextButton.find(".chevron-swipe");
                                    }

                                    if ($wrapper.hasClass("js-table-swipe") || $wrapper.hasClass("js-slider-swipe")) {
                                        if (clickCount === 0) {
                                            $chevronPrev.removeClass("chevron-swipe-active");
                                            $chevronNext.addClass("chevron-swipe-active");
                                        }
                                        else if (clickCount >= ($wrapper.app.columnCount - $wrapper.app.columnPerPage)) {
                                            // Got to max page
                                            $chevronPrev.addClass("chevron-swipe-active");
                                            $chevronNext.removeClass("chevron-swipe-active");

                                        }
                                        else {
                                            // default
                                            $chevronPrev.addClass("chevron-swipe-active");
                                            $chevronNext.addClass("chevron-swipe-active");

                                        }
                                    }
                                    // If tabs
                                    else if ($wrapper.hasClass("js-tabs-swipe")) {
                                        if (positionTabSlider === minPositionTabSlider) {
                                            $chevronPrev.removeClass("chevron-swipe-active");
                                        }
                                        else {
                                            $chevronPrev.addClass("chevron-swipe-active");
                                        }

                                        if (positionTabSlider === maxPositionTabSlider) {
                                            $chevronNext.removeClass("chevron-swipe-active");
                                        }
                                        else {
                                            $chevronNext.addClass("chevron-swipe-active");
                                        }
                                    }
                                };

                                /*****
                                 * Calls
                                 ********************/
                                $wrapper.app = null;
                                detectSwipe = new Hammer($wrapper[0]); // hammer.js

                                if ($wrapper.hasClass("js-table-swipe")) {
                                    $wrapper.app = new SliderNav($tableHeader, $menu);
                                    $wrapper.app.getHeader(); // d�marre le script
                                }
                                else if ($wrapper.hasClass("js-tabs-swipe")) {
                                    navigationStatus();
                                    $wrapper.app = new SliderNav();
                                    $wrapper.app.setArrows();

                                    var posLeft;
                                    if (pathName.indexOf("onglet") !== -1) {
                                        var userQueryParam = pathName.split("#")[1],
                                            tab = userQueryParam.split("=")[1];

                                        posLeft = $(".js-tab").eq(tab).position().left;
                                        activeTab = tab;

                                        if ((posLeft + tabWidth - tabMargin) > containerWidth) {
                                            for (i = 0; i <= activeTab; i++) {
                                                $wrapper.app.nextPage();
                                            }
                                        }
                                    }
                                    else if (BDC.Utils.gup("tab") != "" || BDC.Utils.gup("cat") != "" ) {

                                        // if tab really exist + add 1 for user experience
                                        var tab = parseInt(BDC.Utils.gup("tab")) - 1;
                                        var cat = parseInt(BDC.Utils.gup("cat")) - 1;

                                        // go to right tab
                                        posLeft = $(".js-tab").eq(tab).position().left;
                                        activeTab = tab;
                                        if ((posLeft + tabWidth - tabMargin) > containerWidth) {
                                            for (i = 0; i <= activeTab; i++) {
                                                $wrapper.app.nextPage();
                                            }
                                        }
                                        //open the right 
                                        if (BDC.Utils.gup("cat") != "") {
                                            var activeCat = $(".js-tabs-wrapper .js-tab-content").eq(tab).find("article").eq(cat),
                                                offset = 0;

                                            activeCat.find(".js-expando").addClass("close-content");
                                            activeCat.find(".js-expand").addClass("show-expand");
                                            setTimeout(function () {
                                                $("html, body").animate({
                                                    scrollTop: activeCat.offset().top - offset
                                                }, 1500);
                                            }, 600);
                                        }

                                    } else if (activeTab >= 0) {
                                        if (typeof $(".js-tab").eq(activeTab).position() != "undefined") {
                                            posLeft = $(".js-tab").eq(activeTab).position().left;
                                            if ((posLeft + tabWidth - tabMargin) > containerWidth) {
                                                for (i = 0; i <= activeTab; i++) {
                                                    $wrapper.app.nextPage();
                                                }
                                            }
                                        }
                                    }

                                    $wrapper.app.setActiveTab();
                                    startSwipe();
                                }
                                else if ($wrapper.hasClass("js-slider-swipe")) {
                                    $wrapper.app = new SliderNav($wrapper.$slides, $menu);
                                    $wrapper.app.getHeader();
                                }
                            }); // END js-swipe each
                        }
                    }, 100);
                }
                timeout();
            }
        }
    });

    window.BDC = BDC;

    if (!$("html").hasClass("js-main-func-applied")) {

        BDC.load.push(
            "BDC.Main",
            [
                "viewportSize",                         //get viewport size, defines global variable BDC.currentBreakpoint according to Bootstrap 3 standards breakpoints and add proper class to HTML tag
                "customFieldBehavior",                  //Enable behaviors on different custom fields.
                "iFrameManagement",                     //Manage all to deal the differents IFrame scenarios across the webSite depending of the Iframe source
                "emailSpamProtection",                  //Email address decoder to avoid email picks by spam bots.
                "boundary",                             //Highligts the good elemnt in the scrollable left nav
                "addFormClassToIframes",
                "fancyBox",                             //Manages Fancybox options and calls depending on the content type and class
                "htmlEnhancer",                         //A list of jQuery selectors to enhance the DOM in specific situations
                "contactUsMap",                         //Adds Canada map and provinces dots in the contactUs section
                "displayNoteForBusinessCentre",         //displays a business center note if variable and target identifier are passed into function
                "toggleElement",						//Expand Collapse elements
                "clickableBlocks",						//by clicking on divs redirect the page to its href
                "slidingTable",                         // add a sliding on fake tables
                "boxSlide",                              //Manage slider boxes in page.
                "blogContentChange"                    //Displayfix for bolog author mobile-large
            ]
        );

        $("html").addClass("js-main-func-applied");
    }

    //Listen to requests sent by Validation Form : Messages received contains the height of the form and function will apply this
    //height to the concerned Iframe.  This will adjust automatically the iframe to the height of the form.
    if (window.addEventListener) {
        addEventListener("message", BDC.Main.iframeListener, false);
    } else {
        attachEvent("onmessage", BDC.Main.iframeListener);
    }

    return true;
})(jQuery, document, window, (window.BDC || {}));

/**
* All the functions relatives to the mobile usage
* @copyright 2016 BDC
*
* @namespace Mobile
* @memberof BDC
* @param {object} @global jQuery
* @param {object} document
* @param {object} window
* @param {object} @namespace BDC
*/
(function ($, document, window, BDC) {
    //"use strict";

    if (!window.jQuery) {
        console.error("jQuery is not loaded!");
    }

    BDC.Mobile = $.extend((BDC.Mobile || {}), {

        /**
        * Generates the mobile top navigation menu
        *
        * @function generateMobileTopNavMenu
        * @memberof BDC.Mobile
        */
        generateMobileTopNavMenu: function () {
            if ($(".dropdown-list").length) {
                //show available languages on drop down
                $(".current-language").on("click",function(){
                    $(this).toggleClass("active");
                    $(".dropdown-content").toggleClass("d-block");
                });

                //clicking outside of menu will close it
                $(window).on("click",
                    function(e) {
                        if (!$(e.target).hasClass("current-language") &&
                            !$(e.target).hasClass("dropdown-content") &&
                            !$(e.target).parent().hasClass("dropdown-content")) {
                            $(".current-language").removeClass("active");
                            $(".dropdown-content").removeClass("d-block");
                        }
                    });
            }

            if($(".js-main-menu").length) {
                // DOM change needed for mobile
                const menuHtml = function () {
                    // Set the active link for mobile
                    var spliceDeleteCount = 0; // We will use splice to walk-up page tree and find the page or the lower level parent page that is being displayed in the menu to make it active
                    const homePattern = new RegExp(/^\/((fr|en)(\/)*)?$/,"i"),
                        path = window.location.pathname.toLowerCase(),
                        splitChar = "/",
                        pathArray = path.split(splitChar);

                    //match top level
                    while (pathArray.length > spliceDeleteCount && !homePattern.test(path)) {
                        pathArray.splice((pathArray.length - 1), spliceDeleteCount); // Remove N pages (last pages) from path
                        const finalPath = pathArray.join(splitChar), // To make sure with have a match either with or without the trailing '/'
                            link = $(".js-main-menu").find(`[href=\"${finalPath}\"]`);

                        if (link.length > 1) {
                            // Verify which link is the correct one
                            link.each(function () {
                                const parentLink = $(this).closest("ol").parent().children("a").attr("href");
                                if ($(this).attr("href").indexOf(parentLink) > -1) {
                                    $(this).addClass("nav-link-active");
                                }
                            });
                            break;
                        }
                        else if (link.length === 1) {
                            link.addClass("nav-link-active");
                            break;
                        }
                        spliceDeleteCount++;
                    }

                    $(".js-main-menu .nav").prepend(`<li><a href="#" class="js-main-menu-back nav-link-back menu-link">${BDC.Dict.menuBack[BDC.currentLang]}</a></li>`);
                }; //END menuHtml

                // Set which link are supposed to be shown on mobile
                var setActiveSubmenu = function () {
                    // Reset
                    $(".nav-submenu-active").removeClass("nav-submenu-active");
                    $(".nav-hide-link").removeClass("nav-hide-link");
                    $(".nav-show-link").removeClass("nav-show-link");

                    if ($(".js-main-menu .nav-link-active").next().length) {
                        $(".js-main-menu .nav-link-active").addClass("nav-show-link");
                        $(".js-main-menu .nav-link-active").next().addClass("nav-submenu-active").addClass("nav-indent-link");
                        $(".nav-link-active").parentsUntil(".js-main-menu").each(function() {
                            if ($(this).prop("tagName") === "OL") {
                                !$(this).hasClass("nav") ? $(this).addClass("nav-hide-link").addClass("nav-submenu-active") : $(this).addClass("nav-hide-link");
                            }
                        });
                    }
                    else {
                        var first = false;
                        $(".nav-link-active").parentsUntil(".js-main-menu").each(function () {
                            if ($(this).prop("tagName") === "OL") {
                                if (first) {
                                    !$(this).hasClass("nav") ? $(this).addClass("nav-hide-link").addClass("nav-submenu-active"): $(this).addClass("nav-hide-link");
                                }
                                else if (!$(this).hasClass("nav")) {
                                    $(this).addClass("nav-submenu-active").addClass("nav-indent-link").prev().addClass("nav-show-link");
                                }
                                first = true;
                            }
                        });
                    }
                    // Show the back button for mobile if needed
                    $(".nav-submenu-active").length ? $(".js-main-menu-back").removeClass("hide") : $(".js-main-menu-back").addClass("hide");
                }; //END setActiveSubmenu()
                menuHtml();
                setActiveSubmenu();

                // Toggle the menu when burger menu is clicked
                $(".js-menu-btn").on("click", function() {
                    $(".js-menu-burger").toggleClass("burger-menu-icon-active");
                    $(".js-main-menu").toggleClass("main-menu-active");
                    $(".js-main-menu-overlay").toggleClass("main-menu-overlay-active");
                    
                    $(".burger-menu-label").toggleClass("burger-menu-label-active");
                    $(".burger-menu-label").hasClass("burger-menu-label-active") ? $(".burger-menu-label").text(BDC.Dict.menuClose[BDC.currentLang]) : $(".burger-menu-label").text("menu");
                    if ($(".js-main-menu").hasClass("main-menu-active")) {
                        setActiveSubmenu();
                    }
                });

                // Remove state active on the menu when overlay is clicked
                $(".js-main-menu-overlay").on("click", function () {
                    $(".js-menu-burger").removeClass("burger-menu-icon-active");
                    $(".js-main-menu").removeClass("main-menu-active");
                    $(".js-main-menu-overlay").removeClass("main-menu-overlay-active");
                });

                // Go back one parent in the navigation tree when you click on the back button
                $(".js-main-menu-back").click(function () {
                    const $currentNavHome = $(".js-main-menu .nav-show-link");
                    $currentNavHome.next().hasClass("nav-submenu-active") ? $currentNavHome.next().removeClass("nav-submenu-active").removeClass("nav-indent-link") : $currentNavHome.closest(".nav-submenu-active").removeClass("nav-submenu-active").removeClass("nav-indent-link");
                    $currentNavHome.closest(".nav-submenu-active").addClass("nav-indent-link").prev().addClass("nav-show-link");
                    $currentNavHome.closest(".nav-hide-link").removeClass("nav-hide-link");
                    $currentNavHome.removeClass("nav-show-link");

                    // If no more back are possible, hide button
                    if (!$(".js-main-menu .nav-submenu-active").length) {
                        $(this).addClass("hide");
                    }
                });

                // When link clicked, navigate to page or show next navigation
                $(".js-main-menu a:not(.js-main-menu-back)").click(function (evt) {

                    //target first level
                    if($(".js-menu-btn").css("display") === "none"){
                        
                        //check is top level
                        //check if already clicked
                        //check is viewport max width is 1024
                        //check if has a sibling "ol submenu"
                        if ($(evt.currentTarget).parentsUntil(".nav").length && !$(evt.currentTarget).hasClass("mobile-click") && window.BDC.Utils.breakpoints.isBP("l-down") &&  !$(evt.currentTarget).next().length) {
                            evt.preventDefault();        
                            $(evt.currentTarget).addClass("mobile-click");

                            //doing text match to remove other mobile click classes JUST IN CASE addClass and removeClass are not fired in order
                            var linkText = String($(evt.currentTarget).text()).trim();
                            const levelOneLinks = $(".topNav > ol.nav > li:not(.hide-menu-item-desktop) > a:not(.js-main-menu-back)");

                            //cycle through top links and find non-selected matches
                            $(levelOneLinks).each(function() {
                                const currentLinkText = String($(this).text()).trim();
                                if(!linkText.match(currentLinkText)){
                                    $(this).removeClass("mobile-click");
                                }
                            });
                        }
                    }
                    else if ($(this).next().length > 0 && !$(this).hasClass("nav-show-link")) {
                        evt.preventDefault();
                        $(this).closest("ol").addClass("nav-hide-link").removeClass("nav-indent-link");
                        $(".js-main-menu .nav-show-link").removeClass("nav-show-link");
                        $(this).addClass("nav-show-link");
                        $(this).next().addClass("nav-submenu-active").addClass("nav-indent-link");
                        $(".js-main-menu-back").removeClass("hide");
                    }

                    return true;
                });
            }//END $('.js-main-menu').length){..
        },//END generateMobileTopNavMenu()

        /**
        * Mobile Main menu, footer and left menu event binder
        *
        * @function mobileMenuEventsBinder
        * @memberof BDC.Mobile
        */
        mobileMenuEventsBinder: function () {
            function FooterMenuItem(ele) {

                var menu = this;
                menu.element = $(ele);
                menu.accordToggle = menu.element.find(".js-accord-toggle");

                menu.toggle = function () {
                    //Accordion new concept & arrow visual up and down
                    $(this).next().slideToggle("slow");
                    menu.element.toggleClass("active");
                    $(".js-accord-content").not($(this).next()).slideUp("slow");
                    $(".js-accord-content").not($(this).next()).closest(".footer-useful-links").removeClass("active").find("span").removeClass("arrow-up").addClass("arrow-down");
                    $(this).find("span").toggleClass("arrow-down arrow-up");
                };

                menu.shouldHaveOpenableMenu = function () {
                    return window.matchMedia("(max-width: 991px)").matches;
                };

                menu.construct = function () {

                    menu.accordToggle.unbind("click");
                    menu.element.height("auto");

                    if (menu.shouldHaveOpenableMenu()) {
                        menu.accordToggle.bind("click", menu.toggle);
                    }
                    else {
                        menu.element.find(">*").css("display", "");
                        menu.element.find("span").removeClass("arrow-up").addClass("arrow-down");
                    }
                };

                $(window).bind("orientationchange resize", menu.construct); // Bind build menu to resize
                menu.construct(); // Build menu for the first time
            }

            function menuManager() {
                const thisMenuManager = this;
                var list = new Array();

                thisMenuManager.ManageEvent = function (event) {
                    var menu = this;
                    if (event.type === "Open") {
                        // Close all menu that is not the one that will be open
                        allMenuUse("close", function (pMenu) {
                            if (pMenu.getIsActive()) {
                                return !!$(pMenu.element).not(menu).length;
                            }
                            else {
                                return false;
                            }
                        });
                    }
                };

                thisMenuManager.addMenu = function (menu) {
                    list.push(menu);
                    for (let i = 0; i < menu.Event.length; i++) {
                        menu.element.bind(menu.Event[i], menuManager.ManageEvent);
                    }
                };

                // function to order menus
                // condition got current menu
                function allMenuUse(method, condition) {
                    if (typeof condition != "function") {
                        condition = function () { return true };
                    }
                    for (let i = 0; i < list.length; i++) {
                        if (condition(list[i])) {
                            list[i][method]();
                        }
                    }
                }
            }

            // call menuManager
            menuManager();

            var items = new Array(); // menus are archived in items
            $(".footer-useful-links").each(function () {
                if (!$(this).find(".link-container").length) {
                    items.push(new FooterMenuItem(this));
                }
            });
        }
    }); //END BDC.Mobile func

    window.BDC = BDC;

    if (!$("html").hasClass("js-mobile-func-applied")) {

        BDC.load.push(
            "BDC.Mobile",
            [
                "generateMobileTopNavMenu"         //Generates the mobile top navigation menu
            ]
        );

        $("html").addClass("js-mobile-func-applied");
    }

})(jQuery, document, window, (window.BDC || {}));

window.onload = function () {
    //Load script for loanCalulator:
    if ($(".js-loancalculator").length > 0) {
        const script = document.createElement("script");

        script.src = "/assets/js/loan-calculator/jquery.accrue.js";

        script.async = true;
            
        document.body.appendChild(script);
    }
};

$(document).ready(function () {

    BDC.Mobile.mobileMenuEventsBinder();

    const parentElems = document.querySelectorAll(".js-ajax-form");
    parentElems.forEach(function (parentElem) {
        try {
            new FilteredAjaxForm({
                targetElement: parentElem
            });
        } catch (e) {
            console.log(e);
        }
    });

    //Initialize IframeResizer for site preview modes
    window.IFrameResizer.start(
        window.parent.document.querySelector("iframe[name=sitePreview], iframe[name=advancedSitePreview]"),
        ["div.container"]
    );

    window.StickyStacker.start([".position-sticky, .fixed-header header.header, .advanced-preview-message"]);

    //exple: articles & tools landing: sliders
    BDC.Utils.toggleActiveClassOnClick();
    $(".fn-slide-panel").toggleActiveClassOnClick(false);

    /* Add a new function to random videos when loading the page */
    if ($("#randomVid").length) {
        $("#randomVid .js-random-vid").randomDisplay(); //Random the 3 first videos on /en/bank-devoted-exclusively-to-entrepreneurs/pages/webseries.aspx
    }
});

var timer;

$(window).on("resize orientationchange", function () {

    window.clearTimeout(timer);

    timer = setTimeout(function () {
        BDC.Main.viewportSize();
        BDC.Main.blogContentChange();
    }, 200);
});

window.addEventListener("beforeprint", function() {

    const images = document.querySelectorAll("img.lazyload");

    images.forEach(function(item){
       window.lazySizes.loader.unveil(item);
    });
});